import React from 'react';
import styles from '../policyDetails.module.scss';
import { useRouter } from 'next/navigation';
import { ROUTER_GROUPS } from '@/core/constants/routes';
import { SemiBold16, Regular14, SemiBold14 } from '@/components/design-system';
import { replacePlaceholders } from '@/core/utils/format.utils';
import { IconChevronRight } from '@tabler/icons-react';
import Image from 'next/image';
import { useDashboard } from '@/contexts/dashboard/dashboard.context';
import { PolicyObject } from '@/data/api/policy/types/policyObject.types';
import { filterExpiredAndCancelledPolicies } from '@/core/utils/policy.util';

const ExpiredCancelledComp = ({
  title,
  policies,
}: {
  title: string;
  policies: PolicyObject[];
}) => {
  const { dashboardLabels } = useDashboard();
  const { policyDetailsCms } = dashboardLabels;
  const router = useRouter();

  const length = filterExpiredAndCancelledPolicies(policies).length;

  if (length === 0) return null;

  return (
    <div
      className={styles['cards-con']}
      onClick={() => {
        if (title === 'Cancelled') {
          router.push(`${ROUTER_GROUPS.policy.cancelledPolicySelection}`);
        } else {
          router.push(`${ROUTER_GROUPS.policy.expiredPolicySelection}`);
        }
      }}
    >
      <SemiBold14>{`${title.toLowerCase() === 'expired' ? 'PAST' : title.toUpperCase()} ${length > 1 ? 'POLICIES' : 'POLICY'}`}</SemiBold14>
      <div className={styles['exp-con']}>
        <div className={styles['content-con']}>
          <Image
            src={policyDetailsCms.expiredCancelledView.healthCardImg}
            alt="expired"
            width={48}
            height={48}
          />
          <div className={styles['text-con']}>
            <SemiBold16>
              {replacePlaceholders(policyDetailsCms.expiredCancelled.title, {
                policy: `${length} ${title.toLowerCase() === 'expired' ? 'past' : title.toLowerCase()} ${length > 1 ? 'policies' : 'policy'}`,
              })}
            </SemiBold16>
            <Regular14>
              {replacePlaceholders(policyDetailsCms.expiredCancelled.subtitle, {
                policy: `${title.toLowerCase() === 'expired' ? 'past' : title.toLowerCase()} policies`,
              })}
            </Regular14>
          </div>
        </div>
        <IconChevronRight size={16} color="var(--midnight-500)" />
      </div>
    </div>
  );
};

export default ExpiredCancelledComp;
